import styled from "styled-components";
import { BbotAlert } from "top-component-library";

export const LegacyLinkAlert = styled(BbotAlert)`
  margin-bottom: 15px;
`;

export const SettingHeading = styled.h4`
  margin-bottom: 8px;
`;

export const SettingHint = styled.div`
  color: var(--color-neutral__text-secondary);
  font-size: 16px;
`;

// A label's text and its help-tooltip icon, as two flex items rather than
// inline siblings: AntD's icon baseline otherwise sits lower than the text.
export const LabelWithTooltip = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SettingControl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 240px;
`;

export const SaveRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const MovedCardBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  p {
    margin: 0;
  }
`;

export const SettingControlRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const StackedButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  margin-top: 16px;
`;

export const DayField = styled.div`
  margin-bottom: 12px;

  label {
    display: block;
    font-weight: 500;
    margin-bottom: 4px;
  }
`;

export const WizardFieldRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;
